import {AxiosError} from 'axios'

import {API} from '../../networking/http'
import {QueryOptions, UseQueryOptions} from '../helpers/types'

export type CurrencyRateRounding = {
  mode: 'DOWN' | 'NEAREST' | 'UP'
  decimals: number
}

export type CurrencyRateResponse = {
  enabled: boolean
  baseCurrency: string
  displayCurrency?: string
  thbToGbpRate?: number
  rateUpdatedAt?: string
  rateInfo?: string
  rateLabel?: string
  rounding?: CurrencyRateRounding
}

export type GetCurrencyRateParams = {
  venueId?: string
}

export type GetCurrencyRateQueryParams = {
  venueId?: string
} | null

export type GetCurrencyRateQueryReturnType = CurrencyRateResponse | null

type Par = QueryOptions<GetCurrencyRateParams, GetCurrencyRateQueryParams, GetCurrencyRateQueryReturnType>

type QueOp = UseQueryOptions<
  GetCurrencyRateQueryReturnType,
  AxiosError,
  GetCurrencyRateQueryReturnType,
  [string, GetCurrencyRateQueryParams?]
>

export const makeGetCurrencyRateEndpoint = ({venueId}: GetCurrencyRateParams) => `venues/${venueId}/currency-rate`

export const getCurrencyRateQuery = ({query, params, ...rest}: Par): QueOp => {
  return {
    queryKey: ['getCurrencyRateQuery', {venueId: params?.venueId || ''}],
    cacheTime: 1000 * 60 * 5, // 5 minutes cache
    ...rest,
    refetchOnWindowFocus: rest.refetchOnWindowFocus || false,
    queryFn: ({queryKey: [_, config]}) => {
      if (params?.venueId) {
        return API.get<GetCurrencyRateQueryParams, GetCurrencyRateQueryReturnType>(
          makeGetCurrencyRateEndpoint(params),
          {
            params: config,
            query,
          },
        )
          .then((res) => res.data)
          .catch(() => {
            // Return disabled state on error
            const errorResponse: CurrencyRateResponse = {
              enabled: false,
              baseCurrency: 'THB',
            }
            return errorResponse
          })
      }
      const defaultResponse: CurrencyRateResponse = {
        enabled: false,
        baseCurrency: 'THB',
      }
      return new Promise((res) => res(defaultResponse))
    },
  }
}
